import UserJson from "../../entities/user/UserJson.js";
import AccessLevel from "../../entities/AccessLevel.js";
import Team from "../../entities/Team.js";

export default class Permission {
    /** @type {string} */
    #type;
    /** @type {Team|UserJson} */
    #subject;
    /** @type {AccessLevel} */
    #accessLevel;

    /**
     * @param {string} type
     * @param {Team|UserJson} subject
     * @param {AccessLevel} accessLevel
     */
    constructor(type, subject, accessLevel) {
        this.#type = type;
        this.#subject = subject;
        this.#accessLevel = accessLevel;
    }

    /** @returns {string} */
    get sid () {
        return this.#subject.id
    }

    /** @returns {AccessLevel} */
    get accessLevel(){
        return this.#accessLevel
    }

    /** @returns {string} */
    get type(){
        return this.#type
    }

    /** @returns {boolean} */
    isTeamSid() {
        return this.#type === Permission.SUBJECT_TYPE.TEAM
    }

    /** @returns {boolean} */
    isUserSid() {
        return this.#type === Permission.SUBJECT_TYPE.USER
    }

    /** @param {AccessLevel} accessLevel */
    set accessLevel(accessLevel){
        this.#accessLevel = accessLevel
    }

    /** @returns {string} */
    get name (){
        return this.isTeamSid() ? this.#subject.name : this.#subject.displayName;
    }

    /** @returns {Team|UserJson} */
    get subject (){
        return this.#subject;
    }

    /** @returns {{level: number, id: string, type: string}} */
    createServerJson(){
        return {
            type: this.#type,
            id: this.sid,
            accessLevel: this.#accessLevel.intValue()
        }
    }

    /** @returns {Permission} */
    createCopy(){
        return new Permission(this.#type, this.subject.createCopy(), new AccessLevel(this.accessLevel.intValue()))
    }

    /**
     * @param json
     * @returns {Permission}
     */
    static parseServerJson(json) {
        const subject = json.type === Permission.SUBJECT_TYPE.TEAM ? Team.parseServerJson(json.team)
            : UserJson.parseServerJson(json.user)
        return new Permission(json.type, subject, new AccessLevel(json.level))
    }

    /**
     * @param json
     * @returns {Permission[]}
     */
    static parseServerJsonMany(json) {
        return json.map(j => (Permission.parseServerJson(j)))
    }

    static SUBJECT_TYPE = {
        USER: "USER",
        TEAM: "TEAM"
    }
}